var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.hasSpeechApi)?_c('div',{staticClass:"row"},[_c('h1',[_vm._v("Your browser doesn't support the webkitSpeechRecognition API.")])]):_c('Recorder')],1)}
var staticRenderFns = []

export { render, staticRenderFns }